import { Box, Tooltip } from "@mui/material";

import { useTranslation } from "@/translations";

import { useCounselorPresenceQuery } from "./hooks/useCounselorPresenceQuery";

interface Props {
  counselorId: string | null;
}

export function CounselorPresenceIndicator({ counselorId }: Props) {
  const { t } = useTranslation();
  const { data } = useCounselorPresenceQuery(counselorId);

  if (!counselorId || !data) {
    return null;
  }

  const label = data.isPresent ? t("counselors.presence.present") : t("counselors.presence.absent");

  return (
    <Tooltip title={label}>
      <Box
        role="img"
        aria-label={label}
        tabIndex={0}
        sx={(theme) => ({
          flexShrink: 0,
          width: 12,
          height: 12,
          boxSizing: "border-box",
          borderRadius: "50%",
          border: `2px solid ${data.isPresent ? theme.palette.success.main : theme.palette.grey[600]}`,
          backgroundColor: data.isPresent ? theme.palette.success.main : "transparent",
        })}
      />
    </Tooltip>
  );
}
